import { createPublicTemplateSuggestions } from '@/pages/api/scribeAPIV2';
import { type CreateTemplateSuggestionsResponse } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export const PUBLIC_TEMPLATE_SUGGESTIONS_MUTATION_KEY = [
  'public-template-suggestions',
] as const;

interface PublicTemplateSuggestionsParams {
  text?: string;
  specialtyName?: string;
  country?: string;
  language?: string;
}

export function useMutationPublicTemplateSuggestions() {
  return useMutation<
    CreateTemplateSuggestionsResponse,
    Error,
    PublicTemplateSuggestionsParams
  >({
    mutationKey: PUBLIC_TEMPLATE_SUGGESTIONS_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async ({ text, specialtyName, country, language }) => {
      const { data } = await createPublicTemplateSuggestions({
        text,
        specialty_name: specialtyName,
        country,
        language,
      });
      return data;
    },
  });
}
